module.exports = __webpack_public_path__ + "static/roboto-black-efc5afbeac13a338161849206f0819e6.woff2";